import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BdrTableComponent } from './bdr-table.component';

/**
 * Módulo de bdr-table con Material 15 (MDC) para que mat-select, mat-table, etc. se vean correctamente.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
  declarations: [BdrTableComponent],
  exports: [BdrTableComponent],
})
export class BdrTableModule {}
